import { httpRequest } from "@utils/HttpRequest";
import { IPage } from "@src/types/FmsTypes";
import { IMdUserDetail, IMdUserFields, IMdUserSearch, IResetPwd } from "./rateSetTypes";

class RateSetService {
    /**
     * 分页获取用户列表
     * @param params 
     * @returns 
     */
    async page(params: IMdUserSearch) {
        const userPageUrl = "/feedback/record/list";
        return await httpRequest.post<any>(userPageUrl, params);
    }


    /**
     * insertLocal
     * @param params 
     * @returns 
     */
     async insert(params: any) {
        const url = "/feedback/template/insert";
        return await httpRequest.post<any>(url, params);
    }
    /**
     * insertLocal
     * @param params 
     * @returns 
     */
     async edit(params: any) {
        const url = "/feedback/template/update";
        return await httpRequest.post<any>(url, params);
    }
    


    


}

export const rateSetService = new RateSetService();
